import { Heading1 } from './heading';

export const Title = Heading1;

export default Title;
